import request from '@/utils/request'
//查询店铺介绍
export function getIntroduce (params) {
  return request({
    url: '/shopDecorate/selIntroduce',
    method: 'get',
    params
  })
}
// 保存店铺介绍
export function saveIntroduce (data) {
  return request({
    url: '/shopDecorate/introduce',
    method: 'put',
    data
  })
}
// 修改店铺介绍
export function updateIntroduce (data) {
  return request({
    url: '/shopDecorate/updateIntroduce',
    method: 'put',
    data
  })
}

//查询店招
export function getShopSignage (params) {
  return request({
    url: '/shopDecorate/selShopSignage',
    method: 'get',
    params
  })
}
// 保存店招
export function saveShopSignage (data) {
  return request({
    url: '/shopDecorate/shopSignage',
    method: 'put',
    data
  })
}
// 修改店招
export function updateShopSignage (data) {
  return request({
    url: '/shopDecorate/updateShopSignage',
    method: 'put',
    data
  })
}

//查询首页内容
export function getHomeContent (params) {
  return request({
    url: '/shopDecorate/selHomeContent',
    method: 'get',
    params
  })
}
// 保存首页内容
export function saveHomeContent (data) {
  return request({
    url: '/shopDecorate/homeContent',
    method: 'put',
    data
  })
}
// 修改首页内容
export function updateHomeContent (data) {
  return request({
    url: '/shopDecorate/updateHomeContent',
    method: 'put',
    data
  })
}

//查询自定义栏目页
export function getCustomColumn (params) {
  return request({
    url: '/shopDecorate/selCustomColumn',
    method: 'get',
    params
  })
}
// 添加自定义栏目页
export function saveCustomColumn (data) {
  return request({
    url: '/shopDecorate/customColumn',
    method: 'put',
    data
  })
}
// 修改自定义栏目页
export function updateCustomColumn (data) {
  return request({
    url: '/shopDecorate/updateCustomColumn',
    method: 'put',
    data
  })
}

//查询店铺seo
export function getShopSeo (params) {
  return request({
    url: '/shopDecorate/selShopSeo',
    method: 'get',
    params
  })
}
// 添加店铺seo
export function saveShopSeo (data) {
  return request({
    url: '/shopDecorate/shopSeo',
    method: 'put',
    data
  })
}
// 修改店铺seo
export function updateShopSeo (data) {
  return request({
    url: '/shopDecorate/updateShopSeo',
    method: 'put',
    data
  })
}

//查询店铺背景
export function getBackground (params) {
  return request({
    url: '/shopDecorate/selBackground',
    method: 'get',
    params
  })
}
// 添加店铺背景
export function saveBackground (data) {
  return request({
    url: '/shopDecorate/background',
    method: 'put',
    data
  })
}
// 修改店铺背景
export function updateBackground (data) {
  return request({
    url: '/shopDecorate/updateBackground',
    method: 'put',
    data
  })
}


// WEBPACK FOOTER //
// ./src/api/shopDecoration.js